module.exports = __webpack_public_path__ + "static/media/Leccion-9-10-De-lo-Ordinario-a-los-Extraordinario.f80c84b8.pdf";